export default {
  seeUnarchivedCampaigns: 'बिना खोजे किए चलाए गए अभियान देखें',
  seeArchivedCampaigns: 'संग्रहीत अभियान देखें',
  sendMassSms: 'बड़े पैमाने पर एसएमएस भेजें',
  mustChargeBeforeSendingCampaigns: 'अभियान भेजने से पहले आपको फिर से लोड करना होगा',
  sendSmsCampaignFromFile: 'किसी फाइल से एसएमएस अभियान भेजें',
  createCampaign: 'अभियान बनाएं',
  sendCampaignToDirectory: 'अपनी निर्देशिका में अभियान भेजें',
  forms: 'प्रपत्र',
  unArchive: 'अआरक्षित',
  archive: 'फ़ाइल',
  loadingCampaigns: 'लोडिंग अभियान',
  noCampaignsCreated: 'आपने कोई अभियान नहीं बनाया है',
  type: 'प्रकार',
  status: 'राज्य',
  campaignSuccessfullyArchived: 'सफलतापूर्वक संग्रहीत अभियान',
  sendCampaign: 'अभियान भेजें',
  shippingDateAndTime: 'शिपमेंट की तारीख और समय',
  scheduleCampaign: 'शेड्यूल अभियान',
  campaignReadyAndWaitingToBeSent: 'आपका अभियान तैयार है और भेजे जाने की प्रतीक्षा कर रहा है',
  schedule: 'प्रोग्राम',
  export: 'निर्यात',
  campaignStatus: 'अभियान की स्थिति',
  campaignScope: 'अभियान की पहुंच',
  messagesToBeSent: 'भेजे जाने वाले संदेश',
  thisValueCouldChange: 'यह मान बदल सकता है',
  finalValue: 'अंतिम मूल्य',
  sendingDate: 'शिपिंग तिथि',
  campaignProgress: 'अभियान की प्रगति',
  moreCounters: 'अधिक लेखाकार',
  lessCounters: 'कम लेखाकार',
  importingPeopleProgress: 'लोगों के आयात पर प्रगति',
  importedPeople: 'आयातित लोग',
  peopleAmount: 'कुल लोग',
  importingErrors: 'आयात त्रुटियां',
  sending: 'भेजने',
  sent: 'भेजा | भेजा | भेजा',
  onStandBy: 'आगे की सोचो',
  onDraft: 'ड्राफ्ट',
  scheduled: 'अनुसूचित',
  all: 'सभी',
  pending: 'ढलान',
  deliveredToCarrier: 'वाहक को दिया',
  rejected: 'अस्वीकृत | अस्वीकृत',
  postponed: 'स्थगित कर दिया | स्थगित',
  hardRebound: 'मजबूत उछाल | मजबूत बाउंस',
  softRebound: 'नरम उछाल | नरम उछाल',
  opened: 'खोलें | खोलें',
  inSpam: 'स्पैम में',
  terminated: 'ख़त्म होना | ख़त्म होना',
  inBlackList: 'काली सूची में नाम लिखना',
  inWhiteList: 'व्हाइटलिस्टेड',
  messagePart: 'संदेश हिस्सा | संदेश भागों',
  delivered: 'दिया गया',
  importMorePeople: 'अधिक लोगों का आयात करें',
  loadingUsers: 'लोड िंग उपयोगकर्ता',
  clicked: 'क्लिक',
  multiParts: 'कई भाग',
  seeMessage: 'संदेश देखें',
  noUserDefinedMessage: 'उपयोगकर्ता के पास कोई परिभाषित संदेश नहीं है',
  youAreSeeingTheMessageOf: 'आपको संदेश दिखाई दे रहा है',
  nameOfTheMassSms: 'मास एसएमएस नाम',
  insertMassSmsKeyName: 'यह याद रखने में मदद करने के लिए एक नाम दर्ज करें कि यह बड़े पैमाने पर एसएमएस क्या है',
  noFilePicked: 'आपने फ़ाइल का चयन नहीं किया है',
  downloadFormat: 'डाउनलोड प्रारूप',
  prepareMassSms: 'बड़े पैमाने पर एसएमएस तैयार करें',
  insertMassSmsName: 'मास एसएमएस का नाम दर्ज करें',
  mustPickSmsFile: 'आपको एसएमएस फाइल का चयन करना होगा',
  campaignSuccessfullyCreated: 'सफलतापूर्वक बनाया अभियान',
  campaignName: 'अभियान का नाम',
  insertMassCampaignKeyName: 'यह अभियान किस अभियान के बारे में है. यह याद रखने में मदद करने के लिए एक नाम दर्ज करें',
  campaignType: 'अभियान का प्रकार',
  pickCampaignType: 'अभियान प्रकार का चयन करें',
  writeYourMessageHere: 'अपना संदेश यहां लिखें',
  pickPeopleList: 'लोगों की सूची चुनें',
  pickOrCreateListOfPeopleToCommunicateMessage: 'उन लोगों की सूची चुनें जिनसे आप अपना संदेश संवाद करना चाहते हैं. या किसी बाहरी फ़ाइल से आयात करके एक नई सूची बनाएं।',
  allPeople: 'सभी लोग',
  waitWhileTheListGetsCreated: 'सूची बनाए जाने के दौरान प्रतीक्षा करें',
  noPeopleListPicked: 'आपने लोगों की सूची नहीं चुनी है',
  addYourFirstCondition: 'अपनी पहली शर्त जोड़ें',
  addAnotherCondition: 'एक और शर्त जोड़ें',
  attributeCondition: 'विशेषता की स्थिति',
  actionCondition: 'कार्रवाई की स्थिति',
  segmentPeopleByAttributesAndActions: 'आप उन लोगों को टार्गेट कर सकते हैं. जो आपके व्यवसाय के साथ बातचीत करते हैं. या तो उनकी विशेषताओं से. या आपके प्लेटफ़ॉर्म के भीतर की गई कार्रवाइयों से.',
  youAreAlmostDone: 'आप लगभग कर रहे हैं!',
  yourMessageScope: 'आपका संदेश लोगों तक पहुंच जाएगा',
  prepareCampaign: 'अभियान तैयार करें',
  insertMessageSubject: 'अपने संदेश का विषय दर्ज करें',
  insertMessageHtml: 'अपने संदेश का एचटीएमएल दर्ज करें',
  createHtmlTemplate: 'अपना टेम्प्लेट बनाएं',
  importPeople: 'आयात करने वाले लोग',
  insertCampaignName: 'अभियान का नाम दर्ज करें',
  insertCampaignType: 'अभियान का प्रकार दर्ज करें',
  subject: 'बात',
  insertHtmlTemplate: 'अगले क्षेत्र में एचटीएमएल टेम्पलेट डालें',
  previewTemplate: 'पूर्वावलोकन टेम्पलेट',
  customize: 'अनुकूलित',
  from: 'से',
  until: 'तक',
  attribute: 'विशेषता',
  contains: 'में',
  noContains: 'इसमें शा\ufffd\ufffdिल नहीं है',
  is: 'है',
  isNot: 'यह नहीं है',
  addANameToYourTemplate: 'अपने टेम्पलेट में एक नाम जोड़ें',
  templateName: 'टेम्पलेट नाम',
  save: 'सहेजें',
  // Triggers
  triggers: 'ट्रिगर्स',
  noTitle: 'अनामांकित',
  loadingTriggers: 'लोडिंग ट्रिगर',
  noRegisteredTriggers: 'कोई पंजीकृत ट्रिगर नहीं',
  title: 'शीर्षक',
  executeTriggerWhenActionFire: 'कार्रवाई होने पर ट्रिगर निष्पादित करें',
  customActionToFilter: 'फ़िल्टर करने के लिए कस्टम कार्रवाई',
  actionsToExecute: 'क्रियाओं को निष्पादित किया जाएगा',
  emailBody: 'ईमेल बॉडी',
  smsBody: 'एसएमएस शरीर',
  postRequestData: 'पोस्ट अनुरोध डेटा',
  saveTrigger: 'ट्रिगर सहेजें',
  trigger: 'ट्रिगर',
  new: 'नया',
  edit: 'संपादित',
  add: 'जोड़ें',
  triggerDetails: 'ट्रिगर विवरण',
  triggerScope: 'ट्रिगर रेंज',
  editTrigger: 'ट्रिगर संपादित करें',
  createTrigger: 'ट्रिगर बनाएँ',
  triggerSuccessfullyCreated: 'ट्रिगर सफलतापूर्वक बनाया गया',
  triggerSuccessfullyUpdated: 'ट्रिगर सफलतापूर्वक अपडेट किया गया',
  launchers: 'लांचर',
  actionType: 'कार्रवाई ',
  addNotification: 'सूचना जोड़ें',
  notifications: 'सूचनाएँ',
  loadingNotifications: 'सूचनाएं लोड करना',
  noNotificationsCreated: 'कोई सूचनाएं नहीं बनाई गईं',
  newNotification: 'नई अधिसूचना',
  notificationCreatedSuccessfully: 'सही ढंग से बनाई गई अधिसूचना',
  editNotification: 'अधिसूचना संपादित करें',
  notificationEditedSuccessfully: 'अधिसूचना सही ढंग से संपादित',
  youDontHaveNotifications: 'आपके पास सूचनाएं नहीं हैं',
  invalidFileType: 'अमान्य फ़ाइल प्रकार',
  noDataFound: 'कोई डेटा नहीं मिला',
  clickOnYourFileTypeOrDragHere: 'अपने फ़ाइल प्रकार पर क्लिक करें या इसे यहां खींचें',
  filesSize: '5 Mbs से बड़ी फ़ाइलों की अनुमति नहीं है',
  findQuickAnswer: 'त्वरित उत्तर प्राप्त करें',
  noAnswerFound: 'हमें वह उत्तर नहीं मिल रहा है जिसकी आपको तलाश है',
  titleNewInformation: 'नई जानकारी का शीर्षक',
  waitingForAttention: 'ध्यान की प्रतीक्षा में',
  terminationReason: 'पूरा करने का कारण',
  findTerminationReason: 'समाप्ति का कारण खोजें',
  nameless: 'बेनाम',
  conversationClassification: 'बातचीत का वर्गीकरण',
  withoutAdvisor: 'सलाहकार के बिना',
  you: 'तुम्हारी',
  agents: 'एजेंटों',
  advisors: 'सलाहकारों',
  conversations: 'बात चिट',
  host: 'मेज़बान',
  attended: 'में भाग लिया',
  noAttended: 'भाग नहीं लिया',
  responseTime: 'जवाब देने का समय',
  noAttendedConversations: 'अनुत्तरित वार्तालाप',
  attendedConversations: 'बातचीत में भाग लिया',
  totalConversations: 'कुल बातचीत',
  lastMonth: 'पिछले महीने',
  phone: 'सेलुलर',
  organic: 'कार्बनिक',
  conversationsPerChannel: 'प्रति चैनल बातचीत',
  createdPeople: 'लोगों को बनाया',
  waitTime: 'प्रतीक्षा समय',
  yesterday: 'बिता कल',
  withBot: 'बॉट के साथ',
  assignTaskAfterSettingJourney: 'यात्रा निर्धारित करने के बाद कार्य सौंपें',
  pickAJourneyStatus: 'यात्रा की स्थिति चुनें',
  journeys: 'यात्रा',
  timeInMinutesToCreateTaskAfterSettingJourney: 'जर्नी सेट करने के बाद टास्क बनाने के लिए मिनटों में समय',
  untrainedQuestions: 'अप्रशिक्षित प्रश्न',
  numberOfQuestions: 'प्रश्नों की संख्या',
  serviceRating: 'सेवा रेटिंग',
  usersWhoGotProactivity: 'जिन उपयोगकर्ताओं को सक्रियता मिली',
  bot: 'रोबोट',
  questions: 'प्रशन',
  operator: 'ऑपरेटर',
  time: 'मौसम',
  attendedAndUnansweredConversations: 'संलग्न और अनअटेंडेड वार्तालाप',
  total: 'संपूर्ण',
  pickExtraData: 'अतिरिक्त डेटा चुनें',
  pickExtraDataFieldAndValue: 'अतिरिक्त डेटा फ़ील्ड और मान चुनें',
  writeExtraDataValue: 'अतिरिक्त डेटा मान लिखें',
  campaignInformation: 'अभियान की जानकारी',
  // Trigger to do list translations
  smsToUser: 'उपयोगकर्ता के लिए एसएमएस',
  emailToUser: 'उपयोगकर्ता के लिए ईमेल',
  postRequestToServer: 'सर्वर के लिए पोस्ट अनुरोध',
  createTaskForUser: 'उपयोगकर्ता के लिए कार्य बनाएँ',
  // Trigger action types translations
  ACTION_CUSTOM: 'कस्टम कार्रवाई',
  ACTION_REGISTER_EMAIL: 'ईमेल रजिस्टर पर',
  ACTION_REGISTER_PHONE: 'फोन रजिस्टर पर',
  ACTION_REGISTER_VERIFIED: 'रजिस्टर सत्यापित पर',
  ACTION_REGISTER_EMAIL_RESEND: 'रजिस्टर रजिस्टर ईमेल पर',
  ACTION_REGISTER_SOCIAL: 'रजिस्टर पर सोशल नेटवर्क के साथ',
  ACTION_REGISTER_GOOGLE: 'उपयोगकर्ता के लिए ईमेल0',
  ACTION_REGISTER_FACEBOOK: 'उपयोगकर्ता के लिए ईमेल1',
  ACTION_REGISTER_SPOTIFY: 'उपयोगकर्ता के लिए ईमेल2',
  ACTION_REGISTER_INSTAGRAM: 'उपयोगकर्ता के लिए ईमेल3',
  ACTION_REGISTER_APPLEID: 'उपयोगकर्ता के लिए ईमेल4',
  ACTION_REGISTER_EMAIL_FAIL: 'उपयोगकर्ता के लिए ईमेल5',
  ACTION_REGISTER_PHONE_FAIL: 'उपयोगकर्ता के लिए ईमेल6',
  ACTION_LOGIN_EMAIL: 'उपयोगकर्ता के लिए ईमेल7',
  ACTION_LOGIN_PHONE: 'उपयोगकर्ता के लिए ईमेल8',
  ACTION_LOGIN_SOCIAL: 'उपयोगकर्ता के लिए ईमेल9',
  ACTION_LOGIN_GOOGLE: 'सर्वर के लिए पोस्ट अनुरोध0',
  ACTION_LOGIN_FACEBOOK: 'सर्वर के लिए पोस्ट अनुरोध1',
  ACTION_LOGIN_INSTAGRAM: 'सर्वर के लिए पोस्ट अनुरोध2',
  ACTION_LOGIN_SPOTIFY: 'सर्वर के लिए पोस्ट अनुरोध3',
  ACTION_LOGIN_APPLEID: 'सर्वर के लिए पोस्ट अनुरोध4',
  ACTION_LOGIN_MAIL_ONE_TIME_PASSWORD: 'सर्वर के लिए पोस्ट अनुरोध5',
  ACTION_LOGIN_MAIL_ONE_TIME_PASSWORD_FAIL: 'सर्वर के लिए पोस्ट अनुरोध6',
  ACTION_LOGIN_PHONE_ONE_TIME_PASSWORD: 'सर्वर के लिए पोस्ट अनुरोध7',
  ACTION_LOGIN_PHONE_ONE_TIME_PASSWORD_FAIL: 'सर्वर के लिए पोस्ट अनुरोध8',
  ACTION_LOGIN_EMAIL_FAIL: 'सर्वर के लिए पोस्ट अनुरोध9',
  ACTION_LOGIN_EMAIL_FAIL_USER: 'उपयोगकर्ता के लिए कार्य बनाएँ0',
  ACTION_LOGIN_EMAIL_FAIL_AUTHS: 'उपयोगकर्ता के लिए कार्य बनाएँ1',
  ACTION_LOGIN_EMAIL_FAIL_WRONG_PSW: 'उपयोगकर्ता के लिए कार्य बनाएँ2',
  ACTION_LOGIN_PHONE_FAIL: 'उपयोगकर्ता के लिए कार्य बनाएँ3',
  ACTION_LOGIN_PHONE_FAIL_USER: 'उपयोगकर्ता के लिए कार्य बनाएँ4',
  ACTION_LOGIN_PHONE_FAIL_AUTHS: 'उपयोगकर्ता के लिए कार्य बनाएँ5',
  ACTION_LOGIN_PHONE_FAIL_WRONG_PSW: 'उपयोगकर्ता के लिए कार्य बनाएँ6',
  ACTION_RESET_PASSWORD_PHONE: 'उपयोगकर्ता के लिए कार्य बनाएँ7',
  ACTION_RESET_PASSWORD_EMAIL: 'उपयोगकर्ता के लिए कार्य बनाएँ8',
  ACTION_RESET_VALIDATION: 'उपयोगकर्ता के लिए कार्य बनाएँ9',
  ACTION_RESET_OTP: 'कस्टम कार्रवाई0',
  ACTION_LOGOUT: 'कस्टम कार्रवाई1',
  ACTION_SUBMIT: 'कस्टम कार्रवाई2',
  ACTION_SUBMIT_FILE: 'कस्टम कार्रवाई3',
  ACTION_USER_IMAGE: 'कस्टम कार्रवाई4',
  ACTION_EVENT_PURCHASE: 'कस्टम कार्रवाई5',
  ACTION_EVENT_PURCHASE_CONFIRMATION: 'कस्टम कार्रवाई6',
  ACTION_USER_CHANGE: 'कस्टम कार्रवाई7',
  ACTION_ON_JOURNEY_SET: 'कस्टम कार्रवाई8',
  ACTION_ON_EXTRADATA_FIELD_CHANGE: 'कस्टम कार्रवाई9',
  ACTION_ON_EXTRADATA_VALUE_CHANGE: 'ईमेल रजिस्टर पर0',
  attachFiles: 'फ़ाइलों को संलग्न करें',
  attachFilesInCampaignDescription: `
  अपने ईमेल अभियान में फ़ाइलें संलग्न करने के लिए,
  प्रत्येक फ़ाइल जो आप संलग्न करते हैं, उसका वजन केवल 5mb और फ़ाइलों का कुल आकार हो सकता है
  से कम वजन होना चाहिए {size} {units}.
  `,
  sizeOfFileCantExceed: 'प्रत्येक फ़ाइल का आकार पार नहीं कर सकता {size} {units}',
  filesTotalSizeMustBeSmallerThan: 'आपकी फ़ाइलों का कुल आकार अधिक नहीं हो सकता {size} {units}',
  attachedFiles: 'संलग्न फाइल',
  fileSuccessfullyDeleted: 'फ़ाइल सफलतापूर्वक हटा दी गई',
  fileWithSameNameAlreadyExists: 'समान नाम वाली फ़ाइल पहले से मौजूद है',
  filesSuccessfullyAttached: 'फ़ाइल सफलतापूर्वक संलग्न की गई'
}
